import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AllPartnerPersonTasks, PaginationParams } from '../tasks';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { TaskSearchService } from './task-search.service';
import { GlobalService } from '../../core/global.service';

@Component({
  selector: 'app-task-search',
  templateUrl: './task-search.component.html',
  styleUrls: ['./task-search.component.scss']
})
export class TaskSearchComponent implements OnInit {
  taskStatus = { OverDue: 1, Warning: 2, OnTime: 3, Complete: 4, NC: 5, Paused: 6, UA: 7, Processing: 120 };
  paginationParams: PaginationParams = { Offset: 0, PageSize: 10, SortValue: 'LoanNumber', SortDir: 'Asc' };
  searchText = '';
  totalRecords = 0;
  rowlimit = 5;
  loading: boolean = false;
  pagination: object = {};
  pageChange: any;
  api: string = (<any>_GlobalNS).api.task.search;
  excelUri: string = (<any>_GlobalNS).api.task.buildExcel;
  searchCriteria: any;
  private apiTaskSearchResponse: any = [];
  taskResult: any = [];
  rowGroupMetadata: any;

  constructor(private changeDetectorRef: ChangeDetectorRef, private _searchSvc: TaskSearchService,
    private _globalSvc: GlobalService) { }

  ngOnInit() {
    this.loading = true;
    this.searchCriteria = this.cleanupSearchParams(this._globalSvc.find((<any>_GlobalNS).paths.taskSearchCriteria));
    this._searchSvc
      .search(this.api, this.searchCriteria)
      .subscribe(res => {
        this.apiTaskSearchResponse = (<any>res).data;
        //consume the API data and save to a private variable then reassign to a public one for the view
        this.taskResult = this.apiTaskSearchResponse;
        this.pagination = (<any>res).meta.pagination;
        this.totalRecords = (<any>res).meta.pagination.TotalRecords;
        this.rowlimit = (<any>res).meta.pagination.PageSize || this.rowlimit;
        this.updateRowGroupMetaData();
        this.loading = false;
      });

  }
  onSort() {
    this.updateRowGroupMetaData();
  }
  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (this.taskResult) {
      for (let i = 0; i < this.taskResult.length; i++) {
        let rowData = this.taskResult[i];
        let LenderPublicName = rowData.LenderPublicName;
        if (i == 0) {
          this.rowGroupMetadata[LenderPublicName] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = this.taskResult[i - 1];
          let previousRowGroup = previousRowData.LenderPublicName;
          if (LenderPublicName === previousRowGroup)
            this.rowGroupMetadata[LenderPublicName].size++;
          else
            this.rowGroupMetadata[LenderPublicName] = { index: i, size: 1 };
        }
      }
    }
  }
  loadData = (paginatedSearchCriteria) => {
    this.loading = true;

    this._searchSvc
      .search(this.api, paginatedSearchCriteria)
      .subscribe(res => {
        this.apiTaskSearchResponse = (<any>res).data;
        //consume the API data and save to a private variable then reassign to a public one for the view
        this.taskResult = this.apiTaskSearchResponse;
        this.pagination = (<any>res).meta.pagination;
        this.totalRecords = (<any>res).meta.pagination.TotalRecords;
        this.rowlimit = (<any>res).meta.pagination.PageSize || this.rowlimit;
        this.updateRowGroupMetaData();
        this.loading = false;
      });
  }
  /* set pagination / sort parameters
  and load paginated data  */
  loadPaginatedData(event): void {
    this.searchCriteria = this.cleanupSearchParams(this._globalSvc.find((<any>_GlobalNS).paths.taskSearchCriteria));
    (<any>this).searchCriteria.Offset = (event.first !== undefined ? event.first : this.paginationParams.Offset);
    (<any>this).searchCriteria.PageSize = (event.rows !== undefined ? event.rows : this.paginationParams.PageSize);
    this.loadData(this.searchCriteria);
  }
  clearSearchBox(obj): void {
    this.searchText = '';
    obj.filterGlobal('', 'contains');
  }
  getStatusClass(taskStatus: number) {
    if (taskStatus === this.taskStatus.OverDue) {
      return 'overdue';
    } else if (taskStatus === this.taskStatus.Warning) {
      return 'warning';
    } else if (taskStatus === this.taskStatus.OnTime) {
      return 'ontime';
    } else if (taskStatus === this.taskStatus.Paused) {
      return 'paused';
    } else if (taskStatus === this.taskStatus.Processing) {
      return 'processing';
    } else {
      return 'complete';
    }
  }
  extendedEventName = (unit: string, eventLabelGroup: string
    , eventLabel: string
    , sequenceNumber: number): string => {
    let extendedEventName: string = '';

    if (unit !== null) {
      return `- ${unit}`;
    }
    if (eventLabel !== null) {
      extendedEventName += `- ${eventLabel}`;
    }
    if (sequenceNumber !== null && Number.isInteger(sequenceNumber) && sequenceNumber > 0) {
      eventLabelGroup !== null && eventLabelGroup.includes("Repair") ?
        extendedEventName += ` - Repair - ${sequenceNumber.toString()}`
        :
        extendedEventName += ` - ${sequenceNumber.toString()}`;
    }
    return extendedEventName;
  }
  completedBy(firstName?: string, lastName?: string): string {
    let completedByFirstName: string;
    let completedByLastName: string;
    completedByFirstName = (firstName !== null ? firstName : '');
    completedByLastName = (lastName !== null ? lastName : '');
    return completedByFirstName + ' ' + completedByLastName;
  }
  getDueCompleteSuffix(task: AllPartnerPersonTasks) {
    let dueCompleteSuffix: string = "";
    if (task.TaskStatusId === this.taskStatus.Paused) {
      dueCompleteSuffix = '(Paused Until)';
    } else if (task.TaskStatusId === this.taskStatus.NC) {
      dueCompleteSuffix = '(NC)';
    } else if (task.TaskStatusId === this.taskStatus.UA) {
      dueCompleteSuffix = '(UA)';
    } else if (task.TaskStatusId === this.taskStatus.Processing) {
      dueCompleteSuffix = '(Processing)';
    }
    return dueCompleteSuffix;
  }
  exportExcel(): string {
    let uri = this.excelUri;
    for (const key in this.searchCriteria) {
      if (key && this.searchCriteria[key]) {
        if (this.searchCriteria[key] !== null && this.searchCriteria[key].length > 0) {
          uri = uri + '&' + key + '=' + this.searchCriteria[key];
        }
      }
    }
    return uri;
  }

  cleanupSearchParams(scrit) {
    let params = {}, val;
    for (let key in scrit) {
      val = scrit[key];
      if (val !== null && val.length > 0) params[key] = val;
    }
    return params;
  }
  propertyUrl(propertyId): string {
    return `${(<any>_GlobalNS).routes.property.viewTasks}&property_id=${propertyId}`;
  }


}
